#import "../fragments/sales-document-fragment.graphql"

mutation UpdateSalesDocumentStatus($input: SalesDocumentUpdateStatusInput!) {
    salesDocumentUpdateStatus(input: $input) {
        salesDocument {
            ...SalesDocumentFragment
        }
    }
}
